import { render, staticRenderFns } from "./business_partner.vue?vue&type=template&id=c03c43a8"
import script from "./business_partner.vue?vue&type=script&lang=js"
export * from "./business_partner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports